import { render, staticRenderFns } from "./injection.vue?vue&type=template&id=5c974942&scoped=true&"
import script from "./injection.vue?vue&type=script&lang=js&"
export * from "./injection.vue?vue&type=script&lang=js&"
import style0 from "./injection.vue?vue&type=style&index=0&id=5c974942&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c974942",
  null
  
)

export default component.exports